import { createContext, useContext } from 'react';
import { type OnImportedHandler } from '../../../../components/sdmSalesPersonCodeMappingImportExport';

type HelpersContext = {
    setOnImported: (onImported: OnImportedHandler) => void;
};

const HelperContext = createContext<HelpersContext | null>(null);

export const useAudiFinancingModulePageHelpers = () => {
    const context = useContext(HelperContext);

    if (!context) {
        throw new Error('useAudiFinancingModulePageHelpers must be used within a proper context provider');
    }

    return context;
};

export default HelperContext;
